module.exports = __webpack_public_path__ + "static/img/result1.cac5b3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/result1.png
// module id = BJC7
// module chunks = 1